
// CAUTION: auto generated by `set-env.ts`
export const environment = {
  production: true,
  apiUrl: '/{{lang}}/graphql',
  mockApiUrl: 'undefined',
  localeUrl: '/{{lang}}/locale',
  kickstartFrontendPort: ':90',
  appVersion: 'build.2023-12-21.',
  langsPresentationOrder: ['fr', 'en'],
  urlPrefix: '/admin'
};
